module.exports = __webpack_public_path__ + "static/8-9812467d7ddeb167429954e7d391bdb5.jpeg";